import { useEffect, useState } from 'react'
import LeftSide from './LeftSide'
import { LayoutThree } from '../../Layout/CommonStyle'
import { setMenuIndex } from '../../../store/userSlice'
import { MenteeMenu } from '../../../models/Enums'
import { RootState, useAppDispatch, useAppSelector } from '../../../store'
import {
  asyncGetFriends,
  asyncGetJobCategories,
  asyncGetMentors,
  setInInventory,
  setOutInventory,
} from '../../../store/mainSlice'
import { Mentor } from '../../../models/User'
import { axiosPost } from '../../Common/Axios'
import { JobInfoRecommend, JobRecommend } from '../../../models/JobRecommend'
import { MentorJobInfoRecommend } from '../../../models/Dto/MentorJobInfoRecommend'
import { registerInventory, unregisterInventory } from '../../Common/CommonApi'
import toast from 'react-hot-toast'
import RecentJobs from '../../Common/RecentJobs'
import Main from './Main'

function MenteeRecommend() {
  const [selectMentorIndex, setSelectMentorIndex] = useState(-1)
  const [selectedMentors, setSelectedMentors] = useState<Mentor[]>([])
  const [jobRecommends, setJobRecommmends] = useState<JobRecommend[]>([])
  const [isSelectFriend, setIsSelectFriend] = useState(false)

  // Display용 Data. Mentor-JobInfoRecommends
  const [mentorJobInfoRecommends, setMentorJobInfoRecommends] = useState<
    MentorJobInfoRecommend[]
  >([])

  const dispatch = useAppDispatch()
  const me = useAppSelector((state: RootState) => state.user.me)
  const mentors = useAppSelector((state: RootState) => state.main.mentors)
  const jobs = useAppSelector((state: RootState) => state.main.jobs)
  const friends = useAppSelector((state: RootState) => state.main.friends)

  // 초기 Loading
  const loadData = async () => {
    const initialLoadMentors = async () => {
      if (mentors.length === 0) {
        await dispatch(asyncGetMentors(me.id))
      }

      // 초기에는 전체 멘토를 선택한다
      if (mentors.length > 0) {
        setSelectedMentors(mentors)
      }
    }

    const initialLoadJobs = async () => {
      if (jobs.length === 0) {
        await dispatch(asyncGetJobCategories())
      }

      if (mentors.length > 0) {
        setSelectedMentors(mentors)
      }
    }

    const loadJobRecommend = async () => {
      const payload = { id: me.id }

      const data = await axiosPost(
        '/api/mentee/get_mentee_job_recommends',
        payload
      )

      setJobRecommmends(data)
    }

    try {
      await initialLoadMentors()
      await initialLoadJobs()
      await loadJobRecommend()
    } catch (error) {}
  }

  const loadFriends = async () => {
    try {
      if (friends.length === 0) {
        await dispatch(asyncGetFriends(me.id))
      }
    } catch (error) {}
  }

  useEffect(() => {
    dispatch(setMenuIndex(MenteeMenu.MENTOR))

    loadFriends()

    loadData()
  }, [])

  useEffect(() => {
    if (mentors.length > 0) {
      setSelectedMentors(mentors)
    }
  }, [mentors])

  // 선택된 멘토가 바뀌었을때 선택된 멘토(들)의 추천 정보를 멘토별로 묶어서 저장한다 (Display용 데이터를 만든다)
  useEffect(() => {
    try {
      const newMentorJobInfoRecommends: MentorJobInfoRecommend[] = []

      if (selectedMentors.length > 0) {
        // mentor당 추천정보들
        const mentorJobInfoRecommends = selectedMentors.map(
          (selectedMentor: Mentor) => {
            const recommends = jobRecommends.filter(
              (jobRecommend) =>
                jobRecommend.sendUserId == selectedMentor.mentor.id
            )

            const jobInfoRecommends: JobInfoRecommend[] = recommends.map(
              (jobRecommend) => {
                const job = jobs.find((j) => j.id == jobRecommend.jobId)!

                console.log('jobRecommend.jobId', jobRecommend.jobId)

                const recommend: JobInfoRecommend = {
                  id: jobRecommend.id,
                  job: job,
                  isFromMentor: true,
                  sendUserId: selectedMentor.mentor.id,
                  recvUserId: jobRecommend.recvUserId,
                  recommendContent: jobRecommend.recommendContent,
                }
                return recommend
              }
            )

            // 멘토와 jobInfoRecommends를 묶어서 저장한다
            const mentorJobInfoRecommend: MentorJobInfoRecommend = {
              isMentor: true,
              mentor: selectedMentor,
              jobInfoRecommends: jobInfoRecommends,
            }

            return mentorJobInfoRecommend
          }
        )
        newMentorJobInfoRecommends.push(...mentorJobInfoRecommends)
      }

      if (selectMentorIndex < 0) {
        // 친구의 추천정보
        const jobInfoRecommends = jobRecommends
          .filter((jobRecommend) => jobRecommend.isFromMentor === false)
          .map((jobRecommend) => {
            const job = jobs.find((j) => j.id == jobRecommend.jobId)!

            const recommend: JobInfoRecommend = {
              id: jobRecommend.id,
              job: job,
              isFromMentor: true,
              sendUserId: jobRecommend.sendUserId,
              recvUserId: jobRecommend.recvUserId,
              recommendContent: jobRecommend.recommendContent,
            }
            return recommend
          })

        const friendJobInfoRecommends: MentorJobInfoRecommend = {
          isMentor: false,
          mentor: undefined,
          jobInfoRecommends: jobInfoRecommends,
        }

        newMentorJobInfoRecommends.push(friendJobInfoRecommends)
      }

      setMentorJobInfoRecommends(newMentorJobInfoRecommends)
    } catch (error) {}
  }, [jobRecommends, selectedMentors, jobs])

  // left 창에서 멘토가 바뀌었을때 (-1:전체, -2:친구)
  const selectMentor = (mentorIndex: number) => {
    try {
      setSelectMentorIndex(mentorIndex)

      if (mentorIndex === -1) {
        setSelectedMentors(mentors)
      } else if (mentorIndex === -2) {
        setSelectedMentors([])
      } else {
        setSelectedMentors([mentors[mentorIndex]])
      }
    } catch (error) {}
  }

  const handleRegisterInventory = async (jobId: number, isAdd: boolean) => {
    try {
      const userId = me.id

      if (isAdd) {
        await registerInventory(jobId, userId, dispatch)
      } else {
        if (confirm('인벤토리에서 제거하시겠습니까?') === false) {
          return
        }
        await unregisterInventory(jobId, userId, dispatch)
      }
    } catch (error) {}
  }

  return (
    <LayoutThree>
      <Main
        selectedMentors={selectedMentors}
        mentorJobInfoRecommends={mentorJobInfoRecommends}
        onChangeToInventory={handleRegisterInventory}
      />
      <LeftSide
        mentors={mentors}
        selectMentorIndex={selectMentorIndex}
        selectedMentors={selectedMentors}
        selectMentor={selectMentor}
      />
      <RecentJobs />
    </LayoutThree>
  )
}

export default MenteeRecommend
